import { OddStyles } from "sb-legacy-integration";
import { StaticDecimalLocalizator } from "../../helpers";
export var mapSelectionsOdds = function (selections, oddStyle) {
    return selections.map(function (selection) {
        selection.odds = selection.displayOdds[OddStyles[oddStyle]];
        var localizator = StaticDecimalLocalizator.getInstance();
        if (localizator) {
            selection.odds = localizator.localizeOdd(selection.odds, oddStyle);
        }
        return selection;
    });
};
//# sourceMappingURL=mapSelectionsOdds.js.map